const generateId = () => Math.floor(Math.random() * 1e4);
const getRandomInt = (max) => Math.floor(Math.random() * Math.floor(max));

export { generateId, getRandomInt };
//# sourceMappingURL=rand.mjs.map
